export default __webpack_public_path__ + "static/media/bg-login.ee47a14c.jpg";